namespace Nobox {
    //Indrov3
    @Serenity.Decorators.registerEditor()
    export class CurrenciesPlaceEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "left", text: "Left ($n)" });
            this.addItem({ id: "right", text: "Right (n$)" });
        }
    }
}